import { pick, prop } from 'ramda';

import { useIsAdmin } from '@core/js/hooks/user';
import { useAppSelector, useUserSelector } from '@core/js/store/hooks';

import { useCustomUserSelector } from '@interlayer/js/custom/stores/user';

export const useGuestPage = () => {
    const isAdmin = useIsAdmin();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const wasLoggedIn = useCustomUserSelector(prop('wasLoggedIn'));
    const { rootPage, dynamicTags: { DTAG_GUEST_PAGE } } = useAppSelector(pick(['rootPage', 'dynamicTags']));

    return isLoggedIn || wasLoggedIn || isAdmin || !DTAG_GUEST_PAGE
        ? rootPage
        : DTAG_GUEST_PAGE;
};
